import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { navItems } from '../data/navigation';
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  useEffect(() => setOpen(false), [pathname]);
  return <header className="fixed inset-x-0 top-0 z-50 border-b border-line-dark bg-ink/95 backdrop-blur" data-id="element-90" data-mp="uza9yieghs4j">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 lg:px-10" data-id="element-91" data-mp="qxp075x7xtyk">
        <Link to="/" className="flex items-baseline gap-3 focus:outline-none focus-visible:ring-2 focus-visible:ring-bronze-light" data-id="element-92" data-mp="14xgaavkm6q7a">
          <span className="font-serif text-xl text-paper" data-id="element-93" data-mp="zw0t5elk53u6">Jean Pierre Lefranc</span>
          <span className="hidden text-xs text-slate-light md:inline" data-id="element-94" data-mp="2ga0p6eha89c5">Regional Technology Executive</span>
        </Link>
        <Link to="/contact" className="hidden rounded-sm border border-bronze-light/60 px-4 py-2 text-sm text-paper transition-colors duration-150 hover:border-bronze-light lg:inline-flex" data-id="element-95" data-mp="2belaxlfd4bf7">
          Get in touch
        </Link>
        <button type="button" className="rounded p-2 text-paper lg:hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-bronze-light" aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} onClick={() => setOpen(v => !v)} data-id="element-96" data-mp="2jj1bdd7k8f7f">
          {open ? <XIcon className="h-5 w-5" data-id="element-97" data-mp="20ri9xat6p97i" /> : <MenuIcon className="h-5 w-5" data-id="element-98" data-mp="20r8hlgko2pyn" />}
        </button>
      </div>

      <nav aria-label="Sections" className="hidden border-t border-line-dark lg:block" data-id="element-99" data-mp="25i8g2q9fpg39">
        <ul className="mx-auto flex h-12 max-w-7xl items-center justify-between px-10" data-id="element-100" data-mp="25k1oob3lyadw">
          {navItems.map(item => <li key={item.path} data-id="element-101" data-mp="1d1e5x2c337fz">
              <NavLink to={item.path} end={item.path === '/'} className={({
            isActive
          }) => `relative flex items-baseline gap-1.5 whitespace-nowrap py-3 text-sm transition-colors duration-150 focus:outline-none focus-visible:text-paper ${isActive ? 'text-paper' : 'text-slate-light hover:text-paper'}`} data-id="element-102" data-mp="1d0mkgkc7aq3f">
                {({
              isActive
            }) => <>
                    <span className={`text-[11px] tabular-nums ${isActive ? 'text-bronze-light' : 'text-slate-light/70'}`} data-id="element-103" data-mp="m2vw2s65k24n">
                      {item.number}
                    </span>
                    {item.label}
                    {isActive && <motion.span layoutId="nav-underline" className="absolute bottom-0 left-0 right-0 h-px bg-bronze-light" transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-104" data-mp="r0xf5d3kw1g4" />}
                  </>}
              </NavLink>
            </li>)}
        </ul>
      </nav>

      <AnimatePresence data-id="element-105" data-mp="2ezhny4xcebdq">
        {open && <motion.nav id="mobile-nav" aria-label="Sections" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="max-h-[calc(100vh-4rem)] overflow-y-auto border-t border-line-dark bg-ink lg:hidden" data-id="element-106" data-mp="2ex4xf3diqsp2">
            <ul className="mx-auto max-w-7xl px-6 py-3" data-id="element-107" data-mp="2xrtnyl0ix0kp">
              {navItems.map(item => <li key={item.path} data-id="element-108" data-mp="2jw838q1bp2y3">
                  <NavLink to={item.path} end={item.path === '/'} className={({
              isActive
            }) => `flex items-baseline gap-3 py-3 text-base ${isActive ? 'text-paper' : 'text-slate-light'}`} data-id="element-109" data-mp="2nze5znp88bzt">
                    <span className="text-xs tabular-nums text-bronze-light" data-id="element-110" data-mp="1ss5fwv9u7jg8">{item.number}</span>
                    {item.label}
                  </NavLink>
                </li>)}
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}